module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/adverts/adverts-create/adverts-create.component.css
// module id = ./src/app/components/adverts/adverts-create/adverts-create.component.css
// module chunks = main